// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__6yCtT","header":"PatientBlock_header__3J1Lg","label":"PatientBlock_label__laMoy","option":"PatientBlock_option__6jmtp"};